<div #scaleBarRef id="ScaleBarComponent">

  <arcgis-scale-bar #scaleRef></arcgis-scale-bar>

  <div class="card">
    <!-- the panel body -->
    <div class="card-body">
      <div class="row ml-0 mr-0">
        <div class="col pl-0 pr-0 text-right" translate>WIDGET.SCALEBAR.EASTING</div>
        <div class="col pl-1 pr-0 scalebar-easting-value"></div>
      </div>
      <div class="row ml-0 mr-0">
        <div class="col pl-0 pr-0 text-right" translate>WIDGET.SCALEBAR.NORTHING</div>
        <div class="col pl-1 pr-0 scalebar-northing-value"></div>
      </div>
    </div>
  </div>
</div>
